import i18next from 'i18next'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { globalOnDemandVars } from '../../../../helper/context'
import { copyTextToClipBoard, showToastByMenuDirection, truncateDefault } from '../../../../helper/functions'
import { Button, ButtonGroup, Card, EditableText, Popover, Tooltip } from '@blueprintjs/core'
import { hasScrollbarAlways, hasScrollbarIfHover } from '../../../../helper/CSSclasses'
import { OverlayProps } from '../../../../helper/configs'
import produce from 'immer'
import { deleteMediaItemF } from '../../../../backend/mediaItems/deleteData'
import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import { extractCountForId } from '../../../../backend/mediaItems/initData'
import { ImageClass } from './forEachInsertForm/imageHelp'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import DialogComp from '../../../commonInterface/dialog'
import { Type2Or3Item } from '../../../list/uploadType2/class'
import { createUploadType2 } from '../../../../backend/uploadType2/createData'
import { useTranslation } from 'react-i18next'
import ThumbNail from './forEachInsertForm/thumbnail'
import { Type1Item } from './type1Class'

export function OneItemForInsertForm ({ item, items, setItems, ClassForType, dragHandleProps, setDialog }) {
  const [title, setTitle] = useState(item.title)
  useEffect(() => {
    if (title !== item.title) {
      setTitle(item.title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.title])

  const { t } = useTranslation()

  const onConfirm = useCallback(
    (newValue) => {
      const currentIndex = items.findIndex((maybeItem) => (maybeItem.id === item.id))
      setItems(produce(items, draft => {
        const oneItem = draft[currentIndex]
        oneItem.setTitle(newValue)
      }))
    },
    [item.id, items, setItems]
  )
  const onClickForDelete = useCallback(
    (onlyLocalDelete) => {
      const currentIndex = items.findIndex((maybeItem) => (maybeItem.id === item.id))
      setItems(produce(items, draft => {
        draft.splice(currentIndex, 1)
      }))

      if (onlyLocalDelete !== true) {
        deleteMediaItemF(item.globalId).then(() => {
          showToastByMenuDirection({
            message: t('itemDeleted', { itemName: truncateDefault(title) }),
            icon: 'trash',
            action: {
              text: 'Undo',
              onClick: () => {
                setItems(produce(items, draft => {
                  draft.splice(currentIndex, 0, item)
                }))
              }
            }
          })
        })
      }
    }
    ,
    [item, items, setItems, t, title]
  )

  const [cropChange, setCropChange] = useState(null)
  const [currentCrop, setCurrentCrop] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [cropURL, setCropURL] = useState('')
  const onEditButton = useCallback(
    () => {
      if (!item.content.isImage) { setDialog(item.type, <ClassForType.EditDialog item={item} setTitleForLocal={setTitle} />) } else {
        const ImageClassInstance = item.content
        // const ImageURL = `https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`
        setCropURL(`https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`)
        if (ImageClassInstance.cropConfig) {
          setCropChange({
            unit: '%',
            width: ImageClassInstance.cropConfig.width * 100,
            height: ImageClassInstance.cropConfig.height * 100,
            x: ImageClassInstance.cropConfig.x * 100,
            y: ImageClassInstance.cropConfig.y * 100
          })
        }
        setDialogOpen(true)
        //
        // globalOnDemandVars.openGlobalDialog()('Edit Image', (
        //   <React.Fragment>
        //     <div css={css`max-width: 98%; max-height: 90%; overflow: auto; margin: auto;`}>
        //       <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }} onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={ImageURL} />
        //     </div>
        //     <Button css={css`float: right; position: relative; right: 5px; top: 10px;`} text={'Save & Close'} intent={'primary'} onClick={async () => {
        //       if (currentCrop) {
        //         const newImageClassInstance = new ImageClass(ImageClassInstance.name, ImageClassInstance.publicId, currentCrop.width / 100, currentCrop.height / 100, {
        //           x: currentCrop.x / 100,
        //           y: currentCrop.y / 100
        //         })
        //         item.setContent(newImageClassInstance)
        //         if (item.globalId) {
        //           await updateMediaItemF(item.globalId, {
        //             content: JSON.stringify(newImageClassInstance)
        //           })
        //         }
        //         showToastByMenuDirection({
        //           message: `'${truncateDefault(ImageClassInstance.name)}' saved`,
        //           intent: 'primary',
        //           icon: 'saved'
        //         })
        //       }
        //
        //       globalOnDemandVars.closeGlobalDialog()()
        //     }} />
        //   </React.Fragment>
        // ), 'bigger')

        //
        // const transformWidget = cloudinary.createUploadWidget({
        //   cloudName: 'learnobit',
        //   uploadPreset: 'nfcv1f2k',
        //   publicId: ImageClassInstance.publicId,
        //   autoMinimize: true,
        //   cropping: true,
        //   showSkipCropButton: false,
        //   theme: 'minimal',
        //   styles: widgetStyles
        // }, (error, result) => {
        //   if (process.env.NODE_ENV !== 'production') {
        //     console.tron.display({
        //       name: 'cloudinary callback / transform',
        //       value: {
        //         error, result
        //       }
        //       // , important: true
        //     })
        //   }
        //   if (result && result.event === 'queues-end') {
        //     const files = result.info.files
        //     if (files.length > 1) {
        //       throw (new Error('multiple files'))
        //     }
        //
        //     const transformedImageClasses = files.map((file) => {
        //       if (file.status === 'success') {
        //         return new ImageClass(ImageClassInstance.name, file.uploadInfo.public_id, file.customCoordinates.width, file.customCoordinates.height, file.customCoordinates)
        //       } else {
        //         return undefined
        //       }
        //     })
        //
        //     if (transformedImageClasses[0]) {
        //       item.setContent(transformedImageClasses[0])
        //       if (item.globalId) {
        //         updateMediaItemF(item.globalId, {
        //           content: JSON.stringify(transformedImageClasses[0])
        //         })
        //       }
        //       showToastByMenuDirection({
        //         message: `'${truncateDefault(ImageClassInstance.name)}' saved`,
        //         intent: 'primary',
        //         icon: 'saved'
        //       })
        //     }
        //   }
        // })
        //
        // transformWidget.open(null, { files: [`https://res.cloudinary.com/learnobit/image/upload/${ImageClassInstance.publicId}`] })
      }
    },
    [item, setDialog]
  )

  const onUpToType1 = useCallback(
    () => {
      const itemForType1 = new Type1Item(item.type, item.title, item.content, item.id, item.count || extractCountForId(item.id), item.globalId)
      updateMediaItemF(item.globalId, {
        inTypeItems: false,
        inType1Items: true,
        inWaitingItemsForType1: true,
        type1Order: 0
      }).then(() => {
        globalOnDemandVars.set_type1Items(produce(globalOnDemandVars.type1Items(), (draft) => {
          draft.unshift(itemForType1)
        }))
        globalOnDemandVars.set_waitingItemsForType1(produce(globalOnDemandVars.waitingItemsForType1(), (draft) => {
          draft.unshift(itemForType1)
        }))
        onClickForDelete(true)
        showToastByMenuDirection({
          message: `'${truncateDefault(item.title)}' uploaded to Type 1`,
          intent: 'success',
          icon: 'media'
        })
      })
    },
    [item.content, item.count, item.globalId, item.id, item.title, item.type, onClickForDelete]
  )
  const onUpToType2 = useCallback(
    () => {
      const itemForUploadType2 = new Type2Or3Item({
        id: item.globalId,
        type: item.type,
        title: item.title,
        content: item.content
      })
      createUploadType2(itemForUploadType2.id, {
        type: itemForUploadType2.type,
        title: itemForUploadType2.title,
        content: itemForUploadType2.content,
        timeStamp: itemForUploadType2.timeStamp
      }).then(() => {
        globalOnDemandVars.uploadType2s()[itemForUploadType2.id] = itemForUploadType2
        globalOnDemandVars.set_uploadType2sInWaitingList(produce(globalOnDemandVars.uploadType2sInWaitingList(), draft => {
          draft.unshift(itemForUploadType2)
        }))
        onClickForDelete(true)
        showToastByMenuDirection({
          message: `'${truncateDefault(itemForUploadType2.title)}' uploaded to Type 2`,
          intent: 'success',
          icon: 'heat-grid'
        })
      })
    },
    [item.content, item.globalId, item.title, item.type, onClickForDelete]
  )

  return (
    <React.Fragment>
      <Card elevation={2} interactive title={title} css={css`
    position: relative;
    cursor: default !important; justify-content: flex-start;
    overflow-x: auto;
    border: var(--primary3) 1px solid;
    padding: 0; margin-bottom: 5px;
    display: flex;
    & .visibleIfHover {
      visibility: hidden;
    }
    &:hover .visibleIfHover {
      visibility: visible;
    }
    `} className={hasScrollbarIfHover}>
        <div className={'bp3-button bp3-icon-drag-handle-vertical bp3-minimal visibleIfHover'} {...dragHandleProps} />
        <EditableText css={css`flex: auto; margin: auto 0 auto 0; overflow: hidden;
//font-family: "hind", -apple-system, "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Open Sans", "Helvetica Neue", "Icons16", sans-serif;
// image upload 에서 save 했을 경우 height 가 inf 가 돼버림
& span, input {
  max-height: 18px !important;
  line-height: 18px !important;
}
`} confirmOnEnterKey
          spellCheck={false}
          value={title} onChange={setTitle} onConfirm={onConfirm} />
        <span css={css`width: 90px;`} />
        <ButtonGroup minimal className={'visibleIfHover'} css={css`position: absolute; right: 0;`}>
          <Tooltip {...OverlayProps} position='top' content={'Upload to Type 1 (Normal Upload)'} intent={'success'}><Button icon={'media'} intent='success' onClick={onUpToType1} /></Tooltip>
          <Tooltip {...OverlayProps} position='top' content={'Upload to Type 2 (Divide and Conquer This Media)'} intent={'success'}><Button icon={'heat-grid'} intent='success' onClick={onUpToType2} /></Tooltip>
          <Popover {...OverlayProps} canEscapeKeyClose={false} interactionKind='hover-target' position='top'
            content={<div css={css`width: 100px;`}><ThumbNail item={item} /></div>}>
            <Button icon={'edit'} title={t('Edit')} onClick={onEditButton} />
          </Popover>
          <Button icon={'trash'} title={t('Delete')} onClick={onClickForDelete} />
        </ButtonGroup>
      </Card>
      <DialogComp isOpen={dialogOpen} setDialogOpen={setDialogOpen} title={t('editImage')} type={'bigger'}>
        <React.Fragment>
          <div css={css`max-width: 98%; max-height: 90%; overflow: auto; margin: auto;`}>
            <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }} onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={cropURL} />
          </div>
          <Button css={css`float: right; position: relative; right: 5px; top: 10px;`} text={t('Save & Close')} intent={'primary'} onClick={async () => {
            const ImageClassInstance = item.content
            if (currentCrop) {
              if (process.env.NODE_ENV !== 'production') {
                console.tron.display({
                  name: 'uploadType2 - percentCrop',
                  value: {
                    currentCrop
                  }
                  // , important: true
                })
              }
              const newImageClassInstance = new ImageClass(ImageClassInstance.name, ImageClassInstance.publicId, ImageClassInstance.width, ImageClassInstance.height, {
                width: currentCrop.width / 100,
                height: currentCrop.height / 100,
                x: currentCrop.x / 100,
                y: currentCrop.y / 100
              })
              item.setContent(newImageClassInstance)
              if (item.globalId) {
                await updateMediaItemF(item.globalId, {
                  content: JSON.stringify(newImageClassInstance)
                })
              }
              showToastByMenuDirection({
                message: i18next.t('mediaSaved', { mediaName: truncateDefault(newImageClassInstance.name) }),
                intent: 'primary',
                icon: 'saved'
              })
            }

            setDialogOpen(false)
          }} />
        </React.Fragment>
      </DialogComp>
    </React.Fragment>
  )
}
